import React from 'react';

import { useTranslation } from 'react-i18next';

import { Wrapper } from './styles';

interface MarketplaceButtonProps {
    isListed: boolean;
    isLoading?: boolean;
    disabled?: boolean;
    onClick: () => void;
}

export const MarketplaceButton = ({
    isListed,
    onClick,
    isLoading = false,
    disabled = false,
}: MarketplaceButtonProps) => {
    const [translate] = useTranslation(['nft_details', 'marketplace']);
    return (
        <Wrapper
            initial={{ opacity: 0, scale: 0.8, y: 20, x: '-50%' }}
            animate={{ opacity: 1, scale: 1, y: 0, x: '-50%' }}
            exit={{ opacity: 0, scale: 0.8, y: 20, x: '-50%' }}
            onClick={onClick}
            disabled={disabled}
            title={disabled ? 'Disabled in preview mode' : undefined}
        >
            {isLoading
                ? 'Loading...'
                : isListed
                  ? translate('asset-buy-cta', { ns: 'marketplace' })
                  : translate('asset-make-offer-cta', { ns: 'marketplace' })}
        </Wrapper>
    );
};
